// src/cert/iso41001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO41001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 41001 प्रमाणन</h1>
                <p>सुविधा व्यवस्थापन प्रणाली (Facility Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 41001 म्हणजे काय?</h2>
                    <p>
                        ISO 41001:2018 is structured in 10 sections, being also aligned with the structure of ISO 9001:2015. It sets the requirements for the facility management of an organization, focusing on working environment and working conditions, satisfaction of interested parties requirements, motivation and implication of top management, the establishment and monitoring of objectives and continual improvement. The Plan-Do-Check-Act principle also applies to this standard.

                        Necessary aid for the implementation of the ISO 41001: 2018 is the ISO 41012: 2018 standard, which provides a detailed guidance on the overall strategic sourcing process and on how to prepare and implement adequate internal or external FM agreements.

                        BENEFITS OF ISO 41001:2018 CERTIFICATION

                        The cost of this certification is minimal in relation to the benefit of your business: Direct comparative advantage in its operation and promotion and differentiation from the competition. In addition, improving productivity, work environment and process efficiency.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>खर्च कमी</li>
                        <li>कार्यक्षमता वाढते</li>
                        <li>कर्मचारी समाधान</li>
                        <li>जोखीम कमी</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 41001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 41001" />
                </section>
            </div>
        </div>
    );
};

export default ISO41001; // हा ओळ हवीच!